import Worldmap from "../../resources/img/world-map.jpg"
import AboutVideo from '../../resources/videos/video1.mp4';
import Nacional from '../../resources/img/nacional.png';
import Interacional from '../../resources/img/internacional.jpg';
import Logitstica from '../../resources/img/logistica.png';
import { Link, useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Row, Col, Typography, Space, Card, Button } from "antd";
const { Title, Paragraph, Text } = Typography;

const Home = () => {

    const navigate = useNavigate();

    const services = [
        {
            title: "Distribución Nacional",
            img: Nacional,
            desc: "Somos expertos en logística nacional, ofreciendo soluciones rápidas y eficientes para garantizar la distribución oportuna de tus productos en todo el país. Con una red de transporte altamente optimizada, gestionamos el traslado de mercancías de manera segura y ágil, reduciendo costos y tiempos de entrega.",
            delay: 100,
        },
        {
            title: "Distribución Internacional",
            img: Interacional,
            desc: "Con nuestro servicio de logística internacional, facilitamos el transporte y la distribución de tus productos a nivel global. Nos encargamos de la coordinación y gestión de aduanas, transporte marítimo, aéreo y terrestre, asegurando que tus mercancías lleguen a su destino de manera segura y eficiente.",
            delay: 200,
        },
        {
            title: "Logistica Integral",
            img: Logitstica,
            desc: "Ofrecemos soluciones de logística integral, que combinan transporte, almacenamiento, gestión de inventarios y distribución para brindar un servicio completo y personalizado. Nuestro enfoque integral permite optimizar cada etapa de la cadena de suministro, garantizando el flujo eficiente de tus productos desde la manufactura hasta el consumidor final.",
            delay: 300,
        },
    ];

    const valores = [
        "Integridad",
        "Excelencia",
        "Responsabilidad"
    ]

    return (
        <>
            <section id="hero" className="hero section dark-background">
                <img src={Worldmap} alt="" className="hero-bg" data-aos="fade-in" />
                <div className="container">
                    <Row gutter={[24, 24]} align="middle">
                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} xxxl={12}>
                            <Title data-aos="fade-up" className="text-white">
                                Logística confiable que conecta tu negocio con el mundo.
                            </Title>

                            <Paragraph data-aos="fade-up" data-aos-delay="100" style={{ color: '#fff' }}>
                                En GMR ENLACES, somos expertos en logística de transporte, ofreciendo soluciones flexibles y dinámicas que garantizan envíos eficientes tanto a nivel nacional como internacional. Nuestra experiencia y compromiso nos posicionan como una opción confiable para manejar tus necesidades de transporte y distribución.
                            </Paragraph>

                            <Row gutter={[16, 16]} data-aos="fade-up" data-aos-delay="300">
                                <Col xs={12} md={6}>
                                    <div className="stats-item text-center">
                                        <CountUp end={232} duration={2} />
                                        <p>Clientes</p>
                                    </div>
                                </Col>

                                <Col xs={12} md={6}>
                                    <div className="stats-item text-center">
                                        <CountUp end={521} duration={2} />
                                        <p>Proyectos</p>
                                    </div>
                                </Col>

                                <Col xs={12} md={6}>
                                    <div className="stats-item text-center">
                                        <CountUp end={1453} duration={2} />
                                        <p>Viajes</p>
                                    </div>
                                </Col>

                                <Col xs={12} md={6}>
                                    <div className="stats-item text-center">
                                        <CountUp end={650} duration={2} />
                                        <p>Trabajadores</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} xxxl={12} data-aos="zoom-out">
                            <img
                                src="assets/img/hero-img.svg"
                                className="img-fluid"
                                alt=""
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </Row>
                </div>
            </section>

            <section id="about" className="about section">
                <div className="container">
                    <Row gutter={[32, 32]} align="middle">
                        {/* Video */}
                        <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} xxxl={12}
                            order={{ xs: 1, lg: 2 }}
                            data-aos="fade-up" data-aos-delay="200">
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                style={{
                                    width: "100%",
                                    borderRadius: 8,
                                    objectFit: "cover"
                                }}
                            >
                                <source src={AboutVideo} type="video/mp4" />
                                Tu navegador no soporta video HTML5.
                            </video>
                        </Col>

                        {/* Contenido */}
                        <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} xxxl={12}
                            order={{ xs: 2, lg: 1 }} data-aos="fade-up" data-aos-delay="100">

                            <Paragraph>
                                Entendemos que nuestros clientes son el eje principal de nuestro éxito. Por ello, trabajamos con un enfoque en la excelencia operativa, creando un ambiente de colaboración que transforma cada envío en una experiencia única. Nos especializamos en ofrecer servicios personalizados de logística, diseñados para superar tus expectativas y garantizar una entrega puntual y segura.
                            </Paragraph>

                            <Space orientation="vertical" size="large" style={{ width: "100%" }}>
                                <Space align="start">
                                    <ul className="service-extra-list">
                                        {valores.map((item, i) => (
                                            <li key={i} style={{fontWeight: 'bold', fontSize: '16px'}}>
                                                <CheckCircleOutlined style={{ marginRight: 6, color: "#1677ff" }} />
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </Space>
                            </Space>

                            <Title level={5} className="mb-4">Son los valores que nos representan.</Title>
                            <Button color="primary" variant="filled"><Link to="/gmr-enlaces/nosotros">Más de GMR ..</Link></Button>
                        </Col>
                    </Row>
                </div>
            </section>

            <section id="services" className="services section">
                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <Text>Servicios</Text>
                    <Title level={2}>Nuestros Servicios</Title>
                    <Paragraph>
                 
                    </Paragraph>
                </div>

                <div className="container">
                    <Row gutter={[24, 24]}>
                        {services.map((service, index) => (
                            <Col key={index} xs={24} sm={24} md={24} lg={12} xl={12} xxl={8} xxxl={8}
                                data-aos="fade-up" data-aos-delay={service.delay}>
                                <Card
                                    hoverable
                                    cover={
                                        <div className="card-image-wrapper">
                                            <img
                                                alt={service.title}
                                                src={service.img}
                                                className="card-image"
                                            />
                                        </div>
                                    }
                                    style={{ borderRadius: 12 }}
                                >
                                    <Title level={4}>{service.title}</Title>
                                    <Paragraph style={{ textAlign: 'justify' }}>{service.desc}</Paragraph>
                                    <Button color="primary" variant="filled" onClick={() => navigate('/gmr-enlaces/servicios')}>
                                        Saber más..
                                    </Button>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            <section className="cta-parallax">
                <div className="cta-overlay" />

                <div className="container">
                    <Row justify="center" data-aos="zoom-in" data-aos-delay="100">
                        <Col xs={24} sm={22} md={20} lg={16} xl={14}>
                            <div className="cta-content">
                                {/* <Title level={2} style={{ color: "#fff" }}>
                                    Call To Action
                                </Title>

                                <Paragraph className="cta-text">
                                    Duis aute irure dolor in reprehenderit in voluptate velit esse
                                    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                                    cupidatat non proident.
                                </Paragraph>

                                <Button type="primary" size="large" className="cta-button">
                                    Call To Action
                                </Button> */}
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

export default Home
